import { toggleExplicitConsent } from 'publisher/actionsManagement'
import { usePopupOpenerRef } from 'publisher/hooks/use-popup-opener-ref'
import { managementSelectors, useManagement } from 'publisher/store'
import React from 'react'
import { useDispatch } from 'react-redux'
import { BasePublisherCheckbox } from 'src/publisher/entities/checkbox/base-publisher-checkbox'
import { CheckboxEntityInterface } from 'src/shared/entities/checkbox/checkbox-entity.schema'

interface CheckboxProps {
  entity: CheckboxEntityInterface
}

const Checkbox = ({ entity }: CheckboxProps) => {
  const ref = usePopupOpenerRef()
  const dispatch = useDispatch()

  const toggleConfirmed = () => dispatch(toggleExplicitConsent(entity.id))
  const isConfirmed = useManagement(m =>
    managementSelectors.getConfirmedCheckboxesIds(m).includes(entity.id),
  )

  return (
    <BasePublisherCheckbox
      ref={ref}
      entityOrSubEntity={entity}
      checked={isConfirmed}
      onChange={toggleConfirmed}
    />
  )
}

export default Checkbox
